(function () {
  function stepSize(track) {
    var item = track.querySelector('.mt-womo-articles__item');
    if (!item) return Math.round(track.clientWidth * 0.8);

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return Math.round(item.getBoundingClientRect().width + gap);
  }

  function syncArrowPosition(root, track) {
    var media = track.querySelector('.mt-womo-articles__media');
    if (!media) return;

    var height = media.getBoundingClientRect().height;
    if (height > 0) root.style.setProperty('--mt-ar-arrow-top', Math.round(height / 2) + 'px');
  }

  function syncState(root, track) {
    var overflowing = track.scrollWidth - track.clientWidth > 1;
    root.classList.toggle('has-overflow', overflowing);

    var prev = root.querySelector('[data-articles-prev]');
    var next = root.querySelector('[data-articles-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 1);
    if (next) next.classList.toggle('is-hidden', track.scrollLeft >= maxScroll - 1);

    syncArrowPosition(root, track);
  }

  function init(root) {
    if (root.dataset.articlesReady === 'true') return;
    root.dataset.articlesReady = 'true';

    var track = root.querySelector('[data-articles-track]');
    if (!track) return;

    var refresh = function () {
      syncState(root, track);
    };

    refresh();

    root.addEventListener('click', function (event) {
      var prev = event.target.closest('[data-articles-prev]');
      var next = event.target.closest('[data-articles-next]');
      if (!prev && !next) return;

      track.scrollBy({ left: prev ? -stepSize(track) : stepSize(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(refresh);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(refresh).observe(track);
    } else {
      window.addEventListener('resize', refresh);
    }

    window.addEventListener('load', refresh);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.mt-womo-articles').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
